import React from 'react';
import { Link } from 'react-router-dom';
import styles from './TermsOfServicePage.module.css';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className={styles.termsOfServicePage}>
      <div className={styles.termsOfServiceContainer}>
        {/* Header */}
        <div className={styles.termsOfServiceHeader}>
          <div className={styles.termsOfServiceIcon}>
            <svg
              className="w-8 h-8 text-white flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style={{ maxWidth: '32px', maxHeight: '32px' }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            </svg>
          </div>
          <h1 className={styles.termsOfServiceTitle}>Terms of Service</h1>
          <p className={styles.termsOfServiceSubtitle}>
            Please read these terms carefully before using our services.
          </p>
        </div>

        {/* Terms Content */}
        <div className={styles.termsOfServiceContent}>
          <div className={styles.termsOfServiceSection}>
            <h2 className={styles.termsOfServiceSectionTitle}>
              Terms of Service
            </h2>

            <div className={`${styles.termsOfServiceInfoBox} ${styles.blue}`}>
              <h3 className={styles.termsOfServiceSectionTitle}>
                SMS Marketing Consent
              </h3>
              <p className={styles.termsOfServiceInfoText}>
                By consenting to Appelt-Bonfire&apos;s SMS marketing in the
                checkout and initializing a purchase or subscribing via our
                subscription tools, you agree to receive recurring text
                notifications (for your order, including abandoned checkout
                reminders), text marketing offers, and transactional texts,
                including requests for reviews from us, even if your mobile
                number is registered on any state or federal do-not-call list.
              </p>
            </div>

            <h3 className={styles.termsOfServiceSectionTitle}>
              Message Frequency and Consent
            </h3>
            <p className={styles.termsOfServiceText}>
              Message frequency varies. Consent is not a condition of purchase.
              If you wish to unsubscribe from receiving text marketing messages
              and notifications, reply with STOP to any mobile message sent from
              us or use the unsubscribe link we provided you within any of our
              messages.
            </p>

            <h3 className={styles.termsOfServiceSectionTitle}>
              Opt-Out Requirements
            </h3>
            <p className={styles.termsOfServiceText}>
              You understand and agree that alternative methods of opting out,
              such as using alternative words or requests, will not be
              considered a reasonable means of opting out. We do not charge for
              the service, but you are responsible for all charges and fees
              associated with text messaging imposed by your wireless provider.
              Message and data rates may apply.
            </p>

            <h3 className={styles.termsOfServiceSectionTitle}>
              Support and Contact
            </h3>
            <p className={styles.termsOfServiceText}>
              For any questions, please text HELP to the number you received the
              messages from. You can also contact us at{' '}
              <Link to="/contact" className={styles.termsOfServiceLink}>
                our contact page
              </Link>{' '}
              for more information.
            </p>

            <h3 className={styles.termsOfServiceSectionTitle}>
              Service Modifications
            </h3>
            <p className={styles.termsOfServiceText}>
              We have the right to modify any telephone number or short code we
              use to operate the service at any time. You will be notified on
              such occasions.
            </p>

            <h3 className={styles.termsOfServiceSectionTitle}>
              Message Delivery and Liability
            </h3>
            <p className={styles.termsOfServiceText}>
              You agree that any messages you send to a telephone number or
              short code we have changed, including any STOP or HELP requests,
              may not be received, and we will not be liable for honoring
              requests made in such messages.
            </p>

            <div className={`${styles.termsOfServiceInfoBox} ${styles.yellow}`}>
              <h4 className={styles.termsOfServiceSectionTitle}>
                Limitation of Liability
              </h4>
              <p className={styles.termsOfServiceInfoText}>
                To the extent permitted by applicable law, you agree that we
                will not be liable for failed, delayed, or misdirected delivery
                of any information sent through the service, any errors in such
                information, and/or any action you may or may not take in
                reliance on the information or Service.
              </p>
            </div>

            <h3 className={styles.termsOfServiceSectionTitle}>
              Privacy Rights
            </h3>
            <p className={styles.termsOfServiceText}>
              Your right to privacy is important to us. You can see our{' '}
              <Link to="/privacy-policy" className={styles.termsOfServiceLink}>
                Privacy Policy
              </Link>{' '}
              to determine how we collect and use your personal information.
            </p>

            <div className={`${styles.termsOfServiceInfoBox} ${styles.green}`}>
              <h4 className={styles.termsOfServiceSectionTitle}>
                Additional Agreements
              </h4>
              <p className={styles.termsOfServiceInfoText}>
                In addition, you agree to our{' '}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.termsOfServiceLink}
                >
                  Messaging Terms
                </a>{' '}
                and{' '}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.termsOfServiceLink}
                >
                  Messaging Privacy Policy
                </a>
                .
              </p>
            </div>
          </div>
        </div>

        {/* Back to Shopping */}
        <div className={styles.termsOfServiceBackButton}>
          <Link to="/" className={styles.backToShoppingButton}>
            <svg
              className={styles.backToShoppingIcon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            <span>Back to Shopping</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
